<div class="container-fluid trustpilot-box">
    <div class="">
        <div class="">
          <div class="wrapper-left">
            <h3 class="p-title-2 mb-20">Rated #1 by Elite Athletes and Everyday Achievers</h3>
            <p class="desc fm-rubik">The UK’s Most Trusted Meal Prep Solution for Wellness and Peak Performance.</p>
          </div>
        </div>
        <div class=" reviews" [ngClass]="isMobile ? 'mt-5' : ''">
            <p-carousel [value]="items" [numVisible]="4" [numScroll]="2" [circular]="false" [style.width]="'100%'" [autoplayInterval]="3000" *ngIf="!isMobile">
                <ng-template let-item pTemplate="item" style="margin-right: 20px;">
                    <div class="carousel-inner me-2" style="margin-right: 20px; padding: 20px">
                        <div class="item active">
                            <div class="row">
                                <div class="col-md-12 web-left">
                                    <div class="pull-left rating">
                                        <img src="assets/images/star.svg" width="23" height="23" class="img-responsive mr-4">
                                        <img src="assets/images/star.svg" width="23" height="23" class="img-responsive mr-4">
                                        <img src="assets/images/star.svg" width="23" height="23" class="img-responsive mr-4">
                                        <img src="assets/images/star.svg" width="23" height="23" class="img-responsive mr-4">
                                        <img src="assets/images/star.svg" width="23" height="23" class="img-responsive">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="title web-left">{{item.title}}</div>
                                    <div class="descriptions web-left">
                                        <span [innerHTML]="item.desc2"></span>
                                        <span (click)="showMore(item, $event)" *ngIf="item.read_more==0" style="font-weight: 600"> Read more</span>
                                        <span (click)="readLess(item, $event)" *ngIf="item.read_more==1" style="font-weight: 600"> Read less</span>
                                    </div>
                                    <div class="name web-left">{{item.author}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-carousel>
            <p-carousel [value]="items" [numVisible]="1" [numScroll]="1" [circular]="false" [style.width]="'100%'" [autoplayInterval]="3000" *ngIf="isMobile">
                <ng-template let-item pTemplate="item" style="margin-right: 20px;">
                    <div class="carousel-inner me-2" style="margin-right: 20px;">
                        <a href="https://uk.trustpilot.com/review/nutrigenic.co.uk" target="_blank">
                            <div class="item active">
                                <div class="row">
                                    <div class="col-md-12 web-left">
                                        <div class="pull-left rating">
                                            <img src="assets/images/star.svg" width="23" height="23" class="img-responsive">
                                            <img src="assets/images/star.svg" width="23" height="23" class="img-responsive">
                                            <img src="assets/images/star.svg" width="23" height="23" class="img-responsive">
                                            <img src="assets/images/star.svg" width="23" height="23" class="img-responsive">
                                            <img src="assets/images/star.svg" width="23" height="23" class="img-responsive">
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="title web-left">{{item.title}}</div>
                                        <div class="descriptions web-left">{{item.desc2}}
                                            <span (click)="showMore(item, $event)" *ngIf="item.read_more==0" style="font-weight: 600"> Read more</span>
                                            <span (click)="readLess(item, $event)" *ngIf="item.read_more==1" style="font-weight: 600"> Read less</span>
                                        </div>
                                        <div class="name web-left">{{item.author}}</div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </ng-template>
            </p-carousel>
            <div class="mt-4">
                <!-- TrustBox widget - Review Collector -->
                <div #trustbox
                     class="trustpilot-widget"
                     data-locale="en-GB"
                     data-template-id="56278e9abfbbba0bdcd568bc"
                     data-businessunit-id="663cec274a92f9e2215bf10f"
                     data-style-height="52px"
                     data-style-width="100%">
                    <a href="https://uk.trustpilot.com/review/nutrigenic.co.uk" target="_blank" rel="noopener"
                       class="trustpilot-btn"
                       aria-label="Review us on Trustpilot">
                        <span class="trustpilot-text">Review us on</span>
                        <span class="trustpilot-brand">
                            <span class="trustpilot-star" aria-hidden="true">
                                ★
                            </span>
                            <span class="trustpilot-name">Trustpilot</span>
                        </span>
                    </a>

                </div>
                <!-- End TrustBox widget -->
            </div>
		</div>
	</div>
</div><!--.container-->
